module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/music-cloud-ea8c22ccced7c107ccf45272cc7691b6.svg";